import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon, CheckCircleIcon, PlayCircleIcon, LockIcon } from 'lucide-react';
interface Lesson {
  id: number;
  title: string;
  duration: string;
  status: 'completed' | 'in-progress' | 'locked';
}
interface Module {
  id: number;
  title: string;
  lessons: Lesson[];
  completed: number;
  total: number;
}
interface CourseSidebarProps {
  activeModule: number;
  activeLesson: number;
  onModuleChange: (moduleId: number) => void;
  onLessonChange: (lessonId: number) => void;
}
const CourseSidebar: React.FC<CourseSidebarProps> = ({
  activeModule,
  activeLesson,
  onModuleChange,
  onLessonChange
}) => {
  const [expandedModules, setExpandedModules] = useState<number[]>([activeModule]);
  const toggleModule = (moduleId: number) => {
    if (expandedModules.includes(moduleId)) {
      setExpandedModules(expandedModules.filter(id => id !== moduleId));
    } else {
      setExpandedModules([...expandedModules, moduleId]);
    }
  };
  const handleLessonClick = (moduleId: number, lessonId: number) => {
    onModuleChange(moduleId);
    onLessonChange(lessonId);
  };
  const courseModules: Module[] = [{
    id: 1,
    title: "Introduzione all'Innovazione Sostenibile",
    lessons: [{
      id: 1,
      title: 'Concetti fondamentali di sostenibilità',
      duration: '12:30',
      status: 'completed'
    }, {
      id: 2,
      title: "Evoluzione dell'innovazione sostenibile",
      duration: '15:45',
      status: 'completed'
    }, {
      id: 3,
      title: 'Obiettivi di sviluppo sostenibile (SDGs)',
      duration: '18:20',
      status: 'completed'
    }],
    completed: 3,
    total: 3
  }, {
    id: 2,
    title: 'Modelli di Business Sostenibili',
    lessons: [{
      id: 1,
      title: 'Ripensare i modelli di business',
      duration: '20:15',
      status: 'completed'
    }, {
      id: 2,
      title: 'Innovazione del modello di business',
      duration: '18:30',
      status: 'completed'
    }, {
      id: 3,
      title: 'Canvas per la sostenibilità',
      duration: '22:10',
      status: 'completed'
    }, {
      id: 4,
      title: 'Case studies di successo',
      duration: '25:40',
      status: 'completed'
    }],
    completed: 4,
    total: 4
  }, {
    id: 3,
    title: 'Strategie ESG (Environmental, Social, Governance)',
    lessons: [{
      id: 1,
      title: 'Introduzione alle strategie ESG',
      duration: '16:20',
      status: 'in-progress'
    }, {
      id: 2,
      title: 'Fattori ambientali e strategie',
      duration: '19:45',
      status: 'locked'
    }, {
      id: 3,
      title: 'Fattori sociali e inclusione',
      duration: '17:30',
      status: 'locked'
    }, {
      id: 4,
      title: 'Governance e trasparenza',
      duration: '14:50',
      status: 'locked'
    }],
    completed: 0,
    total: 4
  }, {
    id: 4,
    title: 'Tecnologie per la Sostenibilità',
    lessons: [{
      id: 1,
      title: 'Tecnologie emergenti per la sostenibilità',
      duration: '23:10',
      status: 'locked'
    }, {
      id: 2,
      title: 'Energia rinnovabile e storage',
      duration: '21:30',
      status: 'locked'
    }, {
      id: 3,
      title: 'Intelligenza artificiale per la sostenibilità',
      duration: '19:15',
      status: 'locked'
    }],
    completed: 0,
    total: 3
  }, {
    id: 5,
    title: 'Economia Circolare',
    lessons: [{
      id: 1,
      title: "Principi dell'economia circolare",
      duration: '18:40',
      status: 'locked'
    }, {
      id: 2,
      title: 'Design circolare di prodotti e servizi',
      duration: '22:15',
      status: 'locked'
    }, {
      id: 3,
      title: 'Supply chain circolari',
      duration: '20:30',
      status: 'locked'
    }, {
      id: 4,
      title: 'Misurazione della circolarità',
      duration: '16:45',
      status: 'locked'
    }],
    completed: 0,
    total: 4
  }, {
    id: 6,
    title: "Reporting e Misurazione dell'Impatto",
    lessons: [{
      id: 1,
      title: 'Standard di reporting di sostenibilità',
      duration: '19:20',
      status: 'locked'
    }, {
      id: 2,
      title: 'KPI e metriche di sostenibilità',
      duration: '17:35',
      status: 'locked'
    }, {
      id: 3,
      title: "Comunicazione dell'impatto",
      duration: '15:50',
      status: 'locked'
    }],
    completed: 0,
    total: 3
  }, {
    id: 7,
    title: 'Case Studies e Best Practices',
    lessons: [{
      id: 1,
      title: 'Case studies settore manifatturiero',
      duration: '24:10',
      status: 'locked'
    }, {
      id: 2,
      title: 'Case studies settore energetico',
      duration: '21:45',
      status: 'locked'
    }, {
      id: 3,
      title: 'Case studies settore servizi',
      duration: '19:30',
      status: 'locked'
    }],
    completed: 0,
    total: 3
  }, {
    id: 8,
    title: 'Implementazione e Gestione del Cambiamento',
    lessons: [{
      id: 1,
      title: 'Strategie di implementazione',
      duration: '20:15',
      status: 'locked'
    }, {
      id: 2,
      title: 'Gestione del cambiamento organizzativo',
      duration: '18:40',
      status: 'locked'
    }, {
      id: 3,
      title: 'Misurazione del successo',
      duration: '16:25',
      status: 'locked'
    }, {
      id: 4,
      title: "Roadmap per l'innovazione sostenibile",
      duration: '22:30',
      status: 'locked'
    }],
    completed: 0,
    total: 4
  }];
  return <div className="py-2" data-id="element-1071">
      {courseModules.map(module => <div key={module.id} className="mb-2" data-id="element-1072">
          <div className={`px-4 py-3 flex items-center justify-between cursor-pointer hover:bg-gray-50 ${activeModule === module.id && !expandedModules.includes(module.id) ? 'bg-gray-50' : ''}`} onClick={() => toggleModule(module.id)} data-id="element-1073">
            <div className="flex-1" data-id="element-1074">
              <div className="flex items-center" data-id="element-1075">
                <span className="text-sm font-medium text-gray-800" data-id="element-1076">
                  {module.title}
                </span>
              </div>
              <div className="flex items-center text-xs text-gray-500 mt-1" data-id="element-1077">
                <span data-id="element-1078">
                  {module.completed}/{module.total} completate
                </span>
                <div className="w-full max-w-[100px] bg-gray-200 rounded-full h-1.5 ml-2" data-id="element-1079">
                  <div className="bg-custom-green h-1.5 rounded-full" style={{
                width: `${module.completed / module.total * 100}%`
              }} data-id="element-1080"></div>
                </div>
              </div>
            </div>
            <div className="flex items-center" data-id="element-1081">
              {expandedModules.includes(module.id) ? <ChevronUpIcon size={18} className="text-gray-400" data-id="element-1082" /> : <ChevronDownIcon size={18} className="text-gray-400" data-id="element-1083" />}
            </div>
          </div>
          {expandedModules.includes(module.id) && <div className="mt-1 mb-2" data-id="element-1084">
              {module.lessons.map(lesson => <div key={lesson.id} className={`px-6 py-2 flex items-center cursor-pointer 
                    ${activeModule === module.id && activeLesson === lesson.id ? 'bg-gray-50' : 'hover:bg-gray-50'}
                    ${lesson.status === 'locked' ? 'opacity-60' : ''}`} onClick={() => lesson.status !== 'locked' && handleLessonClick(module.id, lesson.id)} data-id="element-1085">
                  <div className="mr-3" data-id="element-1086">
                    {lesson.status === 'completed' && <CheckCircleIcon size={18} className="text-custom-green" data-id="element-1087" />}
                    {lesson.status === 'in-progress' && <PlayCircleIcon size={18} className="text-blue-500" data-id="element-1088" />}
                    {lesson.status === 'locked' && <LockIcon size={18} className="text-gray-400" data-id="element-1089" />}
                  </div>
                  <div className="flex-1" data-id="element-1090">
                    <div className="text-sm text-gray-800" data-id="element-1091">{lesson.title}</div>
                    <div className="text-xs text-gray-500" data-id="element-1092">
                      {lesson.duration}
                    </div>
                  </div>
                </div>)}
            </div>}
        </div>)}
    </div>;
};
export default CourseSidebar;